import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import ImageUploader from '@/admin/ImageUploader';
import { TextField, Section, SaveBar } from '@/admin/AdminUI';

const ROUTES = [
  { key: 'experiences', label: '/experiences' },
  { key: 'speakers', label: '/speakers' },
  { key: 'partners', label: '/partners' },
  { key: 'gallery', label: '/gallery' },
  { key: 'privacy', label: '/privacy' },
  { key: 'terms', label: '/terms' },
  { key: 'faq', label: '/faq' },
  { key: 'contact', label: '/contact' },
];

export default function StubRoutesTab() {
  const [active, setActive] = useState('experiences');
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const load = async (route) => {
    const r = await api.get(`/admin/stub-routes/${route}`);
    setData(r.data || { route });
  };
  useEffect(() => { load(active); }, [active]);

  if (!data) return <div className="font-body text-ink-muted">Loading…</div>;

  const set = (k, v) => setData({ ...data, [k]: v });

  const save = async () => {
    setSaving(true); setSaved(false);
    try {
      await api.put(`/admin/stub-routes/${active}`, {
        title: data.title || '',
        body: data.body || '',
        image: data.image || '',
        back_label: data.back_label || 'Back to Home',
      });
      setSaved(true); setTimeout(() => setSaved(false), 2000);
    } finally { setSaving(false); }
  };

  return (
    <div>
      <Section title="Stub Routes">
        <p className="font-body text-[12px] text-ink-muted mb-3">Edit the content shown on the 8 placeholder routes that aren’t yet full pages.</p>
        <div className="flex gap-2 flex-wrap mb-4" data-testid="stub-route-picker">
          {ROUTES.map((r) => (
            <button
              key={r.key}
              type="button"
              onClick={() => setActive(r.key)}
              className={'font-body font-semibold text-[11px] uppercase tracking-wider2 px-3 py-1.5 rounded-full border ' + (active === r.key ? 'bg-brand-orange text-white border-brand-orange' : 'border-border-line text-ink-primary')}
              data-testid={`stub-route-${r.key}`}
            >
              {r.label}
            </button>
          ))}
        </div>
        <TextField label="Page Title" value={data.title} onChange={(v) => set('title', v)} />
        <TextField label="Body Copy" value={data.body} onChange={(v) => set('body', v)} multiline />
        <ImageUploader value={data.image} onChange={(v) => set('image', v)} label="Optional Image" />
        <TextField label="Back Button Label" value={data.back_label} onChange={(v) => set('back_label', v)} />
      </Section>

      <SaveBar onSave={save} saving={saving} saved={saved} />
    </div>
  );
}
